// extracted by mini-css-extract-plugin
export default {"leftRenderer":"leftRenderer--fd7b5a4d","middleRenderer":"middleRenderer--eac8e7bc","rightRenderer":"rightRenderer--574c182f"};